export default function chunk<T>(input: T[], size: number): T[][] {
  return Array(Math.ceil(input.length / size)).fill(null).map((_, i) => input.slice(i * size, i * size + size));
}
